import styled from 'styled-components';
import { subjectTypes } from '../../@types/entities/subjects.entity';

type PropsMateria = {
  $subject: subjectTypes | string;
}

export const ReminderContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  background: #fff;
  margin: 1em 0;
  width: 100%;
  height: 100%;
  background: #FBFBFB;

  ${({ theme }) => theme.spacing.articleBody}

  p, .listaBullets, .listaNumerica {
    padding: 0 !important;
  }

  ${({ theme }) => theme.typography.normal}

  &::after{
    display: none;
  }

  @media screen and (max-width: 1000px){
    width: calc(90% + 10px);

  }

  @media screen and (max-width: 600px){
    width: 100%;
  }
`;

export const WrapIcon = styled.div<PropsMateria>`
  color: #F05A22;
  fill: currentColor;
`;

export const BoxContainer = styled.div<PropsMateria>`
  position: relative;
  display: flex;
  padding: 24px 32px;
  border-radius: 18px;
  flex-direction: column;
  width: 100%;
  background: #FFDA82;
  border: 2px solid #FF7F50;
  color: #333;

  @media screen and (max-width: 1000px){
    padding: 30px;
  }

  @media screen and (max-width: 600px){
    padding: 30px;
  }

  svg {
    position: absolute;
    transform: translateY(-43px) translateX(-34.5px);
    width: 40px;
    height: 40px;
  }

  p:first-of-type{
    display: none;
  }
`;
